__turbopack_context__.v({
  "active": "navbar-module__QghfKW__active",
  "bar": "navbar-module__QghfKW__bar",
  "dropdownContainer": "navbar-module__QghfKW__dropdownContainer",
  "dropdownItem": "navbar-module__QghfKW__dropdownItem",
  "dropdownMenu": "navbar-module__QghfKW__dropdownMenu",
  "homeNavbar": "navbar-module__QghfKW__homeNavbar",
  "logoImage": "navbar-module__QghfKW__logoImage",
  "menuToggle": "navbar-module__QghfKW__menuToggle",
  "navLink": "navbar-module__QghfKW__navLink",
  "navLinks": "navbar-module__QghfKW__navLinks",
  "navbar": "navbar-module__QghfKW__navbar",
  "open": "navbar-module__QghfKW__open",
  "slideDown": "navbar-module__QghfKW__slideDown",
  "sticky": "navbar-module__QghfKW__sticky",
});
